import {
  decryptData,
  encryptData,
  encryptDataHandler,
} from "utils/dataCipherHelper";
import { instance as axios, setHeaders } from "../config/axiosInstance";

// Create Survey API
export const createSurveyApi = async (data) => {
  const responseData = await axios.post(
    "survey/upsert-survey",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

//  Load Payment SDK API

// Create Survey API
export const getPaymentLinkApi = async (data) => {
  const responseData = await axios.post(
    "payment/initiate-payment",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Create Survey Mcq Api hadndler

export const createSurveyMcqApi = async (data) => {
  const responseData = await axios.post(
    "survey/add-survey-mcq",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Survey List Api Handler
export const surveyListApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// get draft survey question list api
export const surveyDraftQuestionListApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-mcq-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

//  export feedback list API
export const exportFeedbackListAPI = async (data) => {
  const responseData = await axios.get(
    `survey/export-participant-feedback-list?reqData=${encryptData(data)}`
  );
  return decryptData(responseData?.data || "");
};

// get survey template question list
export const surveyTemplateQuestionListApi = async (data) => {
  const responseData = await axios.get(
    `template/question-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// getTemplateListAPI

// get survey template list api
export const getTemplateListAPI = async (data) => {
  const responseData = await axios.get(
    `template/list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Selected Survey Detail Api
export const surveyDetailsApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-detail?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Selected Survey Participant List Api Handler
export const surveyParticipantListApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-participant-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Accept All Participant Feedback

export const acceptAllParticipantFeedback = async (data) => {
  const responseData = await axios.put(
    `survey/change-all-feedback-sruvey-status`,
    { reqData: encryptData(data) },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Delete Selected Survey
export const deleteSelectedSurveyApi = async (data) => {
  const responseData = await axios.delete(
    `survey/delete-survey?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

export const toggleParticipantFeedbackStatusApi = async (data) => {
  const responseData = await axios.put(
    `survey/feedback-survey-participant-status`,
    { reqData: encryptData(data) },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Select Participant Survey Feedback Response

export const participantSelectedSurveyFeedbackApi = async (data) => {
  const responseData = await axios.get(
    `survey/selected-participant-survey-response?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");

  // return decryptData(responseData?.data || "");
};

// Function for get payment status
export const paymentStatusApi = async (data) => {
  const responseData = await axios.get(
    `payment/redirect?reqData=${encryptData(data)}`,
    setHeaders()
  );

  return decryptData(responseData?.data || "");
};
